import React from 'react'
import debounce from '../utils/debounce'

class eqxScreenSize {
    sizes = [
        {name: 'xs', threshold: 576},
        {name: 'sm', threshold: 768},
        {name: 'md', threshold: 992},
        {name: 'lg', threshold: 1200},
        {name: 'xl', threshold: 1400},
    ]
    width: number
    constructor(width: number) {
        this.width = width
    }
    getSize() {
        for (let i = 0; i < this.sizes.length; i++) {
            if (this.width <= this.sizes[i].threshold) {
                return this.sizes[i].name
            }
        }
        return 'xl'
    }
    getSizeThreshold() {
        for (let i = 0; i < this.sizes.length; i++) {
            if (this.width <= this.sizes[i].threshold) {
                return this.sizes[i].threshold
            }
        }
        return undefined
    }
    isSmallerThan(size: string) {
        for (let i = 0; i < this.sizes.length; i++) {
            if (this.sizes[i].name === size) {
                return this.width <= this.sizes[i].threshold
            }
        }
        return false
    }
    isLargerThan(size: string) {
        for (let i = 0; i < this.sizes.length; i++) {
            if (this.sizes[i].name === size) {
                return this.width > this.sizes[i].threshold
            }
        }
        return false
    }
}
const useScreenSize = (): eqxScreenSize => {
    const currentSize = new eqxScreenSize(window.innerWidth)
    const [screenSize, setScreenSize] = React.useState<eqxScreenSize>(currentSize)
    //handle resize
    React.useEffect(() => {
        const handleResize = () => {
            debounce(() => {
                setScreenSize(new eqxScreenSize(window.innerWidth))
            }, 200)()
        }

        window.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    return screenSize
}
export default useScreenSize
